@import "../../../../../shared/styles/base";

$off-color: #cdccd3;
$on-color: #7f76cf;

.ToggleSwitch {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .labelSpan {
    width: calc(100% - 3rem);
  }

  .hiddenInput {
    width: 0;
    height: 0;
    opacity: 0;
  }

  .hiddenInput:focus ~ .Toggle {
    outline: $focus-outline;
  }
}

.Toggle {
  display: inline-flex;
  align-items: center;
  border-radius: 1rem;
  overflow: hidden;
  transition: opacity 0.2s ease;
  min-width: 3rem;
  min-height: 1.5rem;
  position: relative;
  cursor: pointer;

  // The inset coloured area the switch sits in
  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    background-color: $off-color;
    width: 100%;
    height: 100%;
    transition: background-color 0.3s ease;
  }

  // The circular white switch that moves across
  &::after {
    content: "";
    position: absolute;
    background-color: white;
    border-radius: 100%;
    top: 0.25rem;
    left: 0.25rem;
    bottom: 0.25rem;
    width: 1rem;
    height: 1rem;
    transition: transform 0.3s ease;
  }
}

.checked .Toggle {
  &::before {
    background-color: $on-color;
  }

  &::after {
    transform: translateX(1.5rem);
  }
}

.visuallyHideLabel .labelSpan {
  width: 0;
  height: 0;
  display: inline-block;
  overflow: hidden;
}

.disabled .Toggle {
  opacity: 0.5;
  cursor: default;
}

.focusVisible .Toggle {
  box-shadow: $focus-shadow;
}
